export default {
    writeComment: 'Write comments',
    member: 'leave your comment and can @member',
    uploadButtonTips: 'Upload attachments / pictures, up to 8, with a single size of no more than 5MB',
    sizeMax: 'No more than 5M',
    send: 'Send',
    comment: 'comment',
    noComment: 'no comment',
    expand: "Expand",
    collapse: "Collapse",
    reply: 'Reply',
    cancel: 'Cancel',
    sure: 'Ok',
    imageTips1: 'Up to 8 files / pictures can be uploaded',
    uploadFail: 'Upload failure',
    imageTips2: '{text} files are not supported',
    moreThan: 'size over 5M',
    delete: 'Delete',
    sureDeleteComment: 'Are you sure you want to delete this comment?',
    deleteCommentSuccess: 'Delete comment succeeded!',
    moreReplys: 'See all {size} replies >>',
    replyLoaded: 'Pack up reply',
};
